<template>
  <form @submit.prevent="submit">
    <TypeaheadFormGroup
        v-model="data.company_id"
        name="company_id"
        label="Company"
        help-text="The company to attach as a lead to the project."
        :error="(errors.company_id || [])[0]"
        endpoint="/api/v2/companies"
        :token="shared.token"
        path="data.data"
        :result-label-property="row => row.attributes.name"
    />

    <button type="submit" class="btn btn-black btn-block">
      <i class="fa fa-save"></i> Save
    </button>
  </form>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import store from '@/store'
import Errors from '@/mixins/Errors'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: {TypeaheadFormGroup},

  mixins: [Errors],

  props: {
    project: {
      required: true
    },
  },

  data() {
    return {
      data: {},

      loading: true,

      shared: store
    }
  },

  methods: {
    submit() {
      http.post('/api/v2/project-leads', {...this.data, project_id: this.project.id})
          .then(response => {
            notify.success('The project lead was saved')

            this.$emit('created', response.data.data)
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
